import phdFormModel from "./phdFormModel";
const {
  formField: {
    photo,
    //page1
    email,
    password,
    titleNameEng,
    firstNameEng,
    middleNameEng,
    lastNameEng,
    titleNameThai,
    firstNameThai,
    middleNameThai,
    lastNameThai,
    studentId,
    gender,
    dateOfBirth,
    maritalStatus,
    bloodType,
    idCard,
    nationality,

    //page2
    faculty,
    major,
    c2fScholarshipProgram,
    mobileThai,
    mobileCountry,
    mentor_id,
    mentorName,
    mentorEmail,
    startFellowship,
    contractEnd,
    researchArea,
    addressInThailand,
    addressInTheCountryOfResidence,

    //page3
    nameOfTheBachelorDegree,
    graduatedFromUniversityInstitute,
    country,
    dateOfBachelorDegreeGraduation,
    nameOfMasterDegree,
    graduatedMasterFromUniversityInstitute,
    country2,

    // Page 4
    workingExperienceList,
    publication,
    awards,
    cvOrResume
  }
} = phdFormModel;

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  [photo.name]: null,
  [email.name]: "",
  [password.name]: "",
  [titleNameEng.name]: "",
  [firstNameEng.name]: "",
  [middleNameEng.name]: "",
  [lastNameEng.name]: "",
  [titleNameThai.name]: "",
  [firstNameThai.name]: "",
  [middleNameThai.name]: "",
  [lastNameThai.name]: "",
  [studentId.name]: "",
  [gender.name]: "",
  [dateOfBirth.name]: "",
  [maritalStatus.name]: "",
  [bloodType.name]: "",
  [idCard.name]: "",
  [nationality.name]: "",

  [faculty.name]: "",
  [major.name]: "",
  [c2fScholarshipProgram.name]: "",
  [mobileThai.name]: "",
  [mobileCountry.name]: "",
  [mentor_id.name]: "",
  [mentorName.name]: "",
  [mentorEmail.name]: "",
  [startFellowship.name]: "",
  [contractEnd.name]: "",
  [researchArea.name]: "",
  [addressInThailand.name]: "",
  [addressInTheCountryOfResidence.name]: "",

  [nameOfTheBachelorDegree.name]: "",
  [graduatedFromUniversityInstitute.name]: "",
  [country.name]: "",
  [dateOfBachelorDegreeGraduation.name]: "",
  [nameOfMasterDegree.name]: "",
  [graduatedMasterFromUniversityInstitute.name]: "",
  [country2.name]: "",

  [workingExperienceList.name]: [
    {
      [workingExperienceList.subMenu[0].position.name]: "",
      [workingExperienceList.subMenu[0].companyOrganization.name]: "",
      [workingExperienceList.subMenu[0].country.name]: "",
      [workingExperienceList.subMenu[0].started.name]: "",
      [workingExperienceList.subMenu[0].ended.name]: "",
      [workingExperienceList.subMenu[0].stillInRole.name]: false
    }
  ],
  [publication.name]: "",
  [awards.name]: "",
  [cvOrResume.name]: null
};
